module.exports = __webpack_public_path__ + "static/images/icon-redirect.1k9bLUH.svg";